import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/logo/logoEn.png'


const _withScopeId = n => (_pushScopeId("data-v-342ad7d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-nav" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: "分蛋科技"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = ["onClick", "onMouseover", "onMouseout"]
const _hoisted_6 = { class: "cn-label" }
const _hoisted_7 = { class: "popup-wrapper" }
const _hoisted_8 = ["id", "onMouseleave"]
const _hoisted_9 = { class: "pop-content" }
const _hoisted_10 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_11 = { class: "pop-solution" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Board of Directors & Executive officers", -1))
const _hoisted_13 = { class: "pop-solution" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Committee Composition", -1))
const _hoisted_15 = { class: "pop-solution" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Governance Documents", -1))
const _hoisted_17 = ["id", "onMouseleave"]
const _hoisted_18 = { class: "pop-content" }
const _hoisted_19 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_20 = { class: "pop-solution" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Company Profile", -1))
const _hoisted_22 = { class: "pop-solution" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Investor Presentations", -1))
const _hoisted_24 = { class: "pop-solution" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Webcast & Events", -1))
const _hoisted_26 = ["id", "onMouseleave"]
const _hoisted_27 = { class: "pop-content" }
const _hoisted_28 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_29 = { class: "pop-solution" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Interim Reports", -1))
const _hoisted_31 = { class: "pop-solution" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Annual Reports", -1))
const _hoisted_33 = { class: "pop-solution" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Analyst Coverage", -1))
const _hoisted_35 = ["id", "onMouseleave"]
const _hoisted_36 = { class: "pop-content" }
const _hoisted_37 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_38 = { class: "pop-solution" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Investor Inquiries", -1))
const _hoisted_40 = { class: "pop-solution" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "IR Contact", -1))
const _hoisted_42 = { class: "pop-solution" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "psfont",
  style: {"color":"rgba(0,0,0,0.6)","font-size":"1rem"}
}, "Annual General Meeting", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.chooseNavLogo && _ctx.chooseNavLogo(...args)))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: _normalizeClass(["ppp", [
        _ctx.navIndex === index ? 'active' : '',
        item.value === 'activity' ? 'relative' : '',
        { 'hide-background': _ctx.hideBackground }
      ]]),
          key: index,
          onClick: ($event: any) => (_ctx.chooseNav(index)),
          onMouseover: ($event: any) => (_ctx.showPopup(index)),
          onMouseout: ($event: any) => (_ctx.hidePopup(index))
        }, [
          _createVNode(_component_router_link, {
            to: { path: item.path},
            style: {"display":"flex","flex-direction":"column","align-items":"center","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","transform":"scale(0.9)"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("span", _hoisted_7, [
            _withDirectives(_createElementVNode("div", {
              style: {"height":"8rem","margin-top":"-5px"},
              id: 'popup-' + index,
              class: "popup",
              onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, { to: {path:'/corporate/Board'} }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_router_link, { to: {path:'/corporate/Committee'} }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_router_link, { to: {path:'/corporate/Governance'} }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 40, _hoisted_8), [
              [_vShow, _ctx.popupVisible[index]]
            ]),
            _withDirectives(_createElementVNode("div", {
              style: {"height":"8rem","margin-top":"-5px"},
              id: 'popup3-' + index,
              class: "popup",
              onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_router_link, { to: {path:'/investorkits/investor_kits'} }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_router_link, { to: {path:'/investorkits/NewInvestor'} }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_router_link, { to: {path:'/investorkits/webcast'} }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 40, _hoisted_17), [
              [_vShow, _ctx.popupVisible[index]]
            ]),
            _withDirectives(_createElementVNode("div", {
              style: {"height":"8rem","margin-top":"-5px"},
              id: 'popup4-' + index,
              class: "popup",
              onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_router_link, { to: {path:'/financial/Interim1'} }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_router_link, { to: {path:'/financial/Interim2'} }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_router_link, { to: {path:'/financial/Interim3'} }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 40, _hoisted_26), [
              [_vShow, _ctx.popupVisible[index]]
            ]),
            _withDirectives(_createElementVNode("div", {
              style: {"height":"8rem","margin-top":"-5px"},
              id: 'popup6-' + index,
              class: "popup",
              onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelHidePopup && _ctx.cancelHidePopup(...args))),
              onMouseleave: ($event: any) => (_ctx.hidePopup(index))
            }, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_router_link, { to: {path:'/shareholder/Investor'} }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_router_link, { to: {path:'/shareholder/Contact'} }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_router_link, { to: {path:'/shareholder/Annual'} }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 40, _hoisted_35), [
              [_vShow, _ctx.popupVisible[index]]
            ])
          ])
        ], 42, _hoisted_5))
      }), 128))
    ])
  ]))
}